module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/product_detail/gallery_1-f081576fa8ac751c893820922a2e3c75.png";